import { render, staticRenderFns } from "./AddEditService.vue?vue&type=template&id=ddb0b5d0&scoped=true"
import script from "./AddEditService.vue?vue&type=script&lang=js"
export * from "./AddEditService.vue?vue&type=script&lang=js"
import style0 from "./AddEditService.vue?vue&type=style&index=0&id=ddb0b5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb0b5d0",
  null
  
)

export default component.exports